<template>
  <div class="xcard">
        
    <div class="row justify-center"> 
      <div class="col-sm-5">
        <v-card>
          <v-card-title class="text-h5 green darken-3 white--text text-center">
            Cambie sus datos de Acceso
          </v-card-title>
      
          <v-card-text>
            <p class="mb-0 mt-4">
                Con el fin de garantizar la seguridad de su cuenta, le solicitamos que cambie su contraseña de inicio de sesión ya que actualmente, está utilizando su número de documento de identidad como contraseña por defecto. Esto implica un alto riesgo de vulnerabilidad, ya que terceros podrían acceder a su cuenta con facilidad.
            </p>
            <p>
                Por lo tanto, le recomendamos encarecidamente que modifique su contraseña lo antes posible para evitar cualquier riesgo de seguridad.
            </p>
            <p>
                Recuerde que la seguridad de su información personal es de suma importancia para nosotros y esperamos que tome las medidas necesarias para garantizar la protección de su cuenta.
            </p> 
          </v-card-text> 
        </v-card>
      </div> 
      <div class="col-sm-5">
        
        <v-card>
          <v-card-title class="text-h5 green darken-3 white--text text-center">
             
          </v-card-title>
      
          <v-card-text>
            <Datos v-on:onaccesschange="onaccesschange()" />
          </v-card-text> 
        </v-card>
      </div> 
    </div>
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import Datos from '@/components/AClave.vue'
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      img_logo: process.env.VUE_APP_LOGO,
      usuario:{
        cargos: [],
      }
    }
  },
  components:{Datos},
  methods:{
    parseUs(){
      if( this.usuario.seg_apellido == null ) this.usuario.seg_apellido = '';
      return this.usuario.nombres+' '+this.usuario.pri_apellido+' '+this.usuario.seg_apellido; 
    },
    salir(){
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.$store.state.isLogin = false;
      //window.location.reload();
      this.activado = false;
      // window.location.href = "/portal"
      window.location.href = '/portal'
    },
    getDatos(){
      var sql = gql`query{getUsuario(id:${this.usuario.id}){ id,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{nombre},sede{nombre}}}}`

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        this.usuario = data.data.getUsuario.datos_personales;
        this.usuario.cargos = data.data.getUsuario.cargos; 

      }).catch((error) => {
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'getUsuario' ) )
      })
    },
    onaccesschange(){ 
      this.salir();
      /*this.$router.push("/");
      window.location.reload(true);*/
    }
  },
  mounted(){
    this.usuario = this.$store.state.DATA_USER;
    this.getDatos();
  }
}
</script>